// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  padding-bottom: 0;
}

#jobTitleBox {
  width: calc(100% - 75px);
  float: left;
}

#jobName {
  line-height: 1.2;
}

#jobScoreBox {
  border: 1px solid #EDF2F5;
  width: 75px;
  height: 75px;
  float: right;
  padding-top: 12px;
}

#bottomDiv {
  margin-top: 10px;
}

#mainSquare {
  position: relative;
  background-color: white;
  border: 1px solid #bcbcbc;
  padding: 15px;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 10;
  opacity: 0.75;
  top: 0;
  left: 0;
}

#targetSquare {
  width: 40px;
  height: 40px;
  border: 1px solid #bcbcbc;
}

#bottomRow {
  margin-top: 8px;
}

.jobSize {
  font-size: 150%;
}

.textBox {
  width: 100%;
  text-align: center;
}

.jobScore {
  color: rgb(119, 156, 197);
  font-size: 150%;
}

.score {
  color: #007566;
  font-size: 150%;
}

.block {
  background-color: #EDF2F5;
  padding: 18px 10px 10px 10px;
  width: calc(50% - 4px);
  height: 90px;
}

#overlayTitle {
  z-index: 11;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 180%;
  text-align: center;
  width: 100%;
  padding-top: 35%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/graphics/iac-sidebar-graph/iac-sidebar-graph.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,WAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACJ","sourcesContent":["p {\n    padding-bottom: 0;\n}\n\n#jobTitleBox {\n    width: calc(100% - 75px);\n    float: left;\n}\n\n#jobName {\n    line-height: 1.2;\n}\n\n#jobScoreBox {\n    border: 1px solid #EDF2F5;\n    width: 75px;\n    height: 75px;\n    float: right;\n    padding-top: 12px\n}\n\n#bottomDiv {\n    margin-top: 10px;\n}\n\n#mainSquare {\n    position: relative;\n    background-color: white;\n    border: 1px solid #bcbcbc;\n    padding: 15px\n}\n\n.overlay {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n    z-index: 10;\n    opacity: 0.75;\n    top: 0;\n    left: 0;\n}\n\n#targetSquare {\n    width: 40px;\n    height: 40px;\n    border: 1px solid #bcbcbc;\n}\n\n#bottomRow {\n    margin-top: 8px;\n}\n\n.jobSize {\n    font-size: 150%;\n}\n\n.textBox {\n    width: 100%;\n    text-align: center;\n}\n\n.jobScore {\n    color: rgb(119,156,197);\n    font-size: 150%;\n}\n\n.score {\n    color: #007566;\n    font-size: 150%;\n}\n\n.block {\n    background-color: #EDF2F5;\n    padding: 18px 10px 10px 10px;\n    width: calc(50% - 4px);\n    height: 90px;\n}\n\n#overlayTitle {\n    z-index: 11;\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 180%;\n    text-align: center;\n    width: 100%;\n    padding-top: 35%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
